import { useSelector } from 'react-redux';
import { addFaqData, hasFaqSelector } from '../Redux/appStateSlice';
import { WithFetchJsonContent } from './WithFetchJsonContent';

export const WithFaqData = ({ children }) => {
  const hasFaq = useSelector(hasFaqSelector);

  return (
    <WithFetchJsonContent reduxInStore={hasFaq} addToReduxFunction={addFaqData} jsonLocation="content/faq">
      {children}
    </WithFetchJsonContent>
  );
};
